import React, { useEffect, useState } from "react";
import TestCard from "./TestCard";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const Test = () => {
  const [test, setTest] = useState(false);
  // မေးခွန်းတစ်ခုချင်းစီရဲ့ အဖြေကို { "questionId": "selectedOption" } ပုံစံဖြင့် သိမ်းမည်
  const [currentLevelAnswers, setCurrentLevelAnswers] = useState({});
  const [data, setData] = useState([]);
  const [mark, setMark] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const currentLevelData = data?.data?.[currentQuestionIndex] || null;

  const handleTest = () => setTest(true);

  // Next နှိပ်တဲ့အခါ လက်ရှိ Level ထဲက မေးခွန်းအားလုံးအတွက် အဖြေစစ်ပြီး Mark ပေါင်းမည်
  const handleNext = () => {
    const questionsInLevel = currentLevelData?.questions || [];
    const answeredCount = Object.keys(currentLevelAnswers).length;

    // Level ထဲက မေးခွန်းအားလုံး ဖြေပြီးမှ Next ပေးသွားမည်
    if (answeredCount === questionsInLevel.length && questionsInLevel.length > 0) {
      let earnedMark = 0;
      
      questionsInLevel.forEach((q) => {
        if (currentLevelAnswers[q._id] === q.correctAnswer) {
          earnedMark += 1;
        }
      });

      setMark((prev) => prev + earnedMark);
      setCurrentLevelAnswers({}); // နောက် Level အတွက် အဖြေဟောင်းများ ရှင်းထုတ်ခြင်း
      setCurrentQuestionIndex((prev) => prev + 1);
    } else {
      alert("Please answer all questions in this section before proceeding.");
    }
  };

  const handlePrev = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
      // Prev ပြန်သွားရင် Mark ပြန်နှုတ်ချင်ရင် ဒီမှာ logic ထည့်နိုင်သည်
    }
  };
const getUserLevel = () => {
  const scoreConfig = data?.score; // API ကလာတဲ့ score object
  if (!scoreConfig) return "Calculating...";

  if (mark >= scoreConfig.advanced) {
    return "Advanced";
  } else if (mark >= scoreConfig.intermediate) {
    return "Intermediate";
  } else if (mark >= scoreConfig.beginner) {
    return "Beginner";
  } else {
    return "Below Beginner";
  }
};
  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/levelstests/view_levelTest`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': "YOUR_JWT_TOKEN_HERE",
          },
        });
        setData(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchInfo();
  }, []);

  return (
    <div className="react-course-filter back__course__page_grid pb---40 pt---110">
      <div className="container pb---70">
        {/* Show instructions before the test starts */}
        {!test && (
          <div className="w-75 level-test-description">
            <p>
              Our academic team conceived this French level test online to allow
              you to <strong>grade your French language skills</strong>.
            </p>
            <p>
              Whether you are a beginner (A1, A2), intermediate (B1, B2) or
              advanced (C1, C2) French user, you can test your{" "}
              <a href="https://www.ila-france.com/levels-french-language-course">
                French level
              </a>{" "}
              online for free and in a short time thanks to our French quiz.
            </p>
            <p>
              This French proficiency test includes 32&nbsp;questions in order
              of increasing difficulty. It lasts 8&nbsp;minutes maximum.
            </p>
            <p>
              This French level test is easily accessible and usable on mobile
              devices.
            </p>
            <p>
              The French level test mainly assesses your written and oral
              comprehension and your grammatical knowledge. It includes multiple
              choice questions relating to these aspects of the French language,
              like a French quiz.
            </p>
            <p>
              After completing the test, your results will be communicated to
              you immediately. You will receive an assessment of your level
              according to the CEFR scale, ranging from A1 to C2:
            </p>
            <ul>
              <li>
                <strong>A1 – Basic user</strong>
                <br />
                At this level, you can understand and use simple expressions for
                everyday situations, introduce yourself and ask basic questions.
                You can interact in a simple way if your interlocutor speaks
                slowly and clearly.
              </li>
              <li>
                <strong>A2 – Basic user</strong>
                <br />
                You understand and use common phrases on familiar topics like
                shopping, local geography, and employment. You can handle simple
                tasks and describe aspects of your daily life.
              </li>
              <li>
                <strong>B1 – Independent user</strong>
                <br />
                You understand the main points of discussions on familiar topics
                and can handle most situations while traveling. You can produce
                simple texts and describe your experiences, dreams, and opinions.
              </li>
              <li>
                <strong>B2 – Independent user</strong>
                <br />
                You understand the main ideas of complex texts and interact with
                native speakers with some ease. You can produce detailed texts
                on a variety of topics and explain points of view.
              </li>
              <li>
                <strong>C1 – Experienced user</strong>
                <br />
                You understand long and complex texts and express yourself
                fluently and spontaneously. You use language flexibly for
                social, academic, and professional purposes, producing
                well-structured texts.
              </li>
              <li>
                <strong>C2 – Experienced user</strong>
                <br />
                You understand everything easily, even complex discussions. You
                can summarize information from different sources and express
                yourself spontaneously and precisely, even in complex
                situations.
              </li>
            </ul>
            <p>
              If you are not satisfied with your French test result, you can do
              it again or book a French course to improve your level, such as{" "}
              <a href="https://www.ila-france.com/french-courses/intensive-french-course-adults">
                intensive French courses
              </a>
              ,{" "}
              <a href="https://www.ila-france.com/french-courses/french-private-training-adults">
                French private courses
              </a>{" "}
              or{" "}
              <a href="https://www.ila-france.com/french-courses/french-university-preparation-course-adults">
                French courses for university students
              </a>
              .
            </p>
            <p>
              Please note that{" "}
              <strong>this online French test is not a placement test</strong>{" "}
              for a French language course booked with us, but it can give you
              an idea of your current level of French. This French level test is
              also not a certification test like the DELF, DALF, or TCF. You can
              find more information about these French exams on the websites of
              the testing organizations, such as the CIEP.
            </p>
            <p>
              If you book a French course at{" "}
              <a href="https://www.ila-france.com/ila-french-language-school">
                ILA French language school
              </a>{" "}
              you will receive a special link and a password to do our online
              placement test in order to place you in the right French level for
              your course.
            </p>
            <p>
              Please, do not use any French books or dictionary as help for this
              online French language proficiency test.
            </p>
            <p>Enjoy the ILA French level test online!</p>
            <div className="test-btn w-100">
              <button
                onClick={handleTest}
                type="button"
                className="btn btn-lg btn-primary"
              >
                Start the test
              </button>
            </div>
          </div>
        )}

        {/* Show questions after test starts */}
        {data.data?.length===0 && test ? (
          <div className="course-message">
          <p className="no-courses">There are no Question now.</p>
        </div>
        ) :test && data.data?.length > 0 &&  (
          currentQuestionIndex < data.data?.length ? (
            <div>
            <TestCard
                currentLevelAnswers={currentLevelAnswers}
                setCurrentLevelAnswers={setCurrentLevelAnswers}
                item={currentLevelData}
              />
            <div className="btn-container">
              <button onClick={handlePrev} className="btn btn-primary mt-5">
                PREV
              </button>
              <button onClick={handleNext} className="btn btn-primary mt-5">
                NEXT
              </button>
            </div>
          </div>
          ):(
            <div className="correct">
            <h3 className="correct-text">
              Congratulations! You have completed the test.
            </h3>
            <h4 className="correct-text">You Corrected {mark} Answers! </h4>
            <div className="level-badge mt-3 mb-4">
       <span className="badge bg-success p-3" style={{ fontSize: '1.2rem' }}>
         Your Level: {getUserLevel()}
       </span>
    </div>
            <Link className="reacbutton" to="/">
              Back to Homepage{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                className="feather feather-arrow-right"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </div>
          )
          
        )
        }

        {/* Show Congratulations message when test is complete */}
      
      </div>
    </div>
  );
};

export default Test;